import {IModalService, IModalInstanceService} from "angular-ui-bootstrap";
import {IPromise, IScope} from "angular";

interface ControllerScope extends IScope {
    watchTheVideo: () => void;
}

export class TmcVideoModal {

    public static id = "tmcVideoModal";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public open(): IPromise<any> {
        const instance = this.$uibModal.open({
            templateUrl: "app/portfolio/templates/ticket/services/tmc-video/TmcVideoModal.html",
            backdrop: "static",
            /** @ngInject */
            controller: ($scope: ControllerScope, $uibModalInstance: IModalInstanceService) => {
                $scope.watchTheVideo = () => {
                    const videoUrl = "https://www.youtube.com/watch?v=fJUrFyUv9Uk";
                    window.open(videoUrl, "_blank");
                    $uibModalInstance.close();
                };
            }
        });

        return instance.result;
    }
}
